import Cookies from 'js-cookie';

import '../sass/citrus-cookie-settings.scss';

(() => {
    const $citrusCookieSettings = document.querySelectorAll('.citrus-cookie-settings');

    if (!$citrusCookieSettings) return;

    $citrusCookieSettings.forEach($citrusCookieSettings => {
        const $necessaryCookies = $citrusCookieSettings.querySelector('input[name="necessary-cookies"]');
        const $analyticalCookies = $citrusCookieSettings.querySelector('input[name="analytical-cookies"]');
        const $marketingCookies = $citrusCookieSettings.querySelector('input[name="marketing-cookies"]');

        const updateCookieSettings = () => {
            Cookies.set('cookieConsent', JSON.stringify({ 
                necessary: $necessaryCookies?.checked ? true : false,
                analytical: $analyticalCookies?.checked ? true : false,
                marketing: $marketingCookies?.checked ? true : false
            }), { expires: 365 });
        };

        const initFormFields = () => {
            $necessaryCookies?.addEventListener('change', updateCookieSettings);
            $analyticalCookies?.addEventListener('change', updateCookieSettings);
            $marketingCookies?.addEventListener('change', updateCookieSettings);
        };

        initFormFields();
    });
})();
